import { useEffect } from 'react';

export default function Cancel() {
  useEffect(() => {
    // Limpiar cualquier dato de sesión si es necesario
    localStorage.removeItem('stripe_session');
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-blue-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-4 text-center">
        <div className="text-yellow-500 text-6xl mb-4">⚠️</div>
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Pago Cancelado</h1>
        
        <p className="text-gray-600 mb-6">
          Tu pago fue cancelado. No se realizó ningún cargo a tu tarjeta.
        </p>
        
        <div className="space-y-3">
          <button
            onClick={() => window.location.href = '/admin'}
            className="w-full bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition-colors"
          >
            Intentar Nuevamente
          </button>
          
          <button
            onClick={() => window.location.href = '/'}
            className="w-full bg-gray-200 text-gray-800 px-6 py-3 rounded-lg hover:bg-gray-300 transition-colors"
          >
            Ir al Inicio
          </button>
        </div>
        
        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>¿Necesitas ayuda?</strong><br />
            Puedes contactarnos en cualquier momento para resolver tus dudas sobre los planes.
          </p>
        </div>
      </div>
    </div>
  );
}
